import qs from "qs";
import request from "@/utils/request";
import requestSC from "@/utils/requestSC";

// 商城导航
export async function getDiamondArea() {
  return requestSC.get("/api/index/queryDiamondArea");
}

// 商城头条
export async function getHeadline(params) {
  return requestSC.get("/api/index/queryHeadline", {
    params
  });
}

// 大数据推荐
export async function getDsjapiRecommendList(params) {
  return request.post("nxin.dsjapi.recommend.detailinfo.list/3.0", qs.stringify(params));
}

// 商城首页获取活动编码
export async function getActivityCode() {
  return request.get("nxin.opensc.activity.list/1.0");
}

// 获取运营中心参数
export async function getYyzxParam() {
  return request.get("nxin.sc.wxmini.yyzxParam.get/1.0");
}

// 根据经纬度获取运营中心及推荐商品
export async function getYyzxList(params) {
  return request.post("nxin.sc.yyzx.goods.list/1.0", qs.stringify(params));
}

// 获取直播信息
export async function getLiveList() {
  return requestSC.get("/api/index/customActivities");
}

// 山东项目推荐商品列表
export async function getSearchGoods(params) {
  return requestSC.post("/rest/goods/es/mob/search", qs.stringify(params));
}

// 山东项目推荐店铺列表
export async function queryShopList(params) {
  return requestSC.post("/mob/shop/queryShopList", qs.stringify(params));
}
